import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, Copy, Row } from '@honda-canada/design-system-react';
import React, { useState } from 'react';
import { selectFinancialCalculator, paymentMethodChanged } from '../../../core/reducers/financialCalculators';
import { ACURA_SITE_NAME, HONDA_SITE_NAME } from '../../../utils/constants';
import { useAppName } from '../../../utils/sitecoreContext';
import TrimPaymentCheckbox from '../../TrimPaymentCheckbox';
import { paymentTabs } from '../../PaymentOptions/constants';
import themeStyles from './styles/InventoryTrimPayment.styles';
import PaymentOptions from '../../PaymentOptions';
import { useAppSelector, useAppDispatch } from '../../../core/utils';
import { selectCurrentVehicle } from '../../../core/reducers/currentVehicle';
import NotImplemented from '../../NotImplemented';
import { getDefaultPaymentOptionsConfig, getDefaultPaymentMethodConfig } from '../../../utils/constants/payment';
import toggleGtmEvent from './utils';
import { selectCurrentVehicleFromVehicles } from '../../../core/reducers/vehicles';
import useFetchCurrentVehiclePaymentByDealerProvince from './useFetchCurrentVehiclePaymentByDealerProvince';
import useInventoryPaymentCalculatorEffect from './useInventoryPaymentCalculatorEffect';
import { INVENTORY_CALCULATOR } from '../constants';
const Title = themeStyles.apply(Copy, 'Title');
const InventoryTrimPayment = ({ title, componentName }) => {
    var _a, _b;
    const appName = useAppName();
    const dispatch = useAppDispatch();
    const { availablePaymentMethods } = useAppSelector(selectCurrentVehicleFromVehicles);
    const availablePaymentTabs = paymentTabs.filter(tab => availablePaymentMethods === null || availablePaymentMethods === void 0 ? void 0 : availablePaymentMethods.includes(tab.method));
    const [activeTab, setActiveTab] = useState(0);
    const defaultPaymentOptions = getDefaultPaymentOptionsConfig(appName);
    const defaultPaymentMethodConfig = getDefaultPaymentMethodConfig(appName);
    const paymentMethod = ((_a = availablePaymentTabs[activeTab]) === null || _a === void 0 ? void 0 : _a.method) || defaultPaymentOptions.paymentMethod;
    const paymentFrequency = defaultPaymentMethodConfig === null || defaultPaymentMethodConfig === void 0 ? void 0 : defaultPaymentMethodConfig[paymentMethod].frequency;
    const currentVehicle = useAppSelector(selectCurrentVehicle);
    const { modelYear, inventoryStatus } = currentVehicle;
    const { overriddenIsSellingProvince, includeFees } = (_b = useAppSelector(state => selectFinancialCalculator(state, INVENTORY_CALCULATOR))) !== null && _b !== void 0 ? _b : {};
    const { data: payment, error, isFetching } = useFetchCurrentVehiclePaymentByDealerProvince(INVENTORY_CALCULATOR);
    const gtmPayload = {
        event: 'dealer_inventory_payment',
        paymentMethod: 'lease',
        availabilityFlag: inventoryStatus,
    };
    useInventoryPaymentCalculatorEffect();
    if (appName !== HONDA_SITE_NAME && appName !== ACURA_SITE_NAME) {
        return _jsx(NotImplemented, { name: componentName });
    }
    const onChangeActiveTab = (tabIndex) => {
        var _a;
        const selectedPaymentMethod = (_a = availablePaymentTabs[tabIndex]) === null || _a === void 0 ? void 0 : _a.method;
        if (!selectedPaymentMethod)
            return;
        setActiveTab(tabIndex);
        dispatch(paymentMethodChanged(INVENTORY_CALCULATOR, selectedPaymentMethod));
        toggleGtmEvent({ ...gtmPayload, paymentMethod: selectedPaymentMethod });
    };
    return paymentMethod && paymentFrequency ? (_jsxs(Row, { "data-component-name": componentName, "data-testid": "cy-trim-payment", children: [_jsxs(Column, { width: [1, 1, 1 / 2], pl: ['20px', '20px', '12px'], pr: ['20px', '20px', 'auto'], children: [_jsx(Title, { "data-testid": "cy-trim-payment-title", size: "subheading", children: title }), _jsx(PaymentOptions, { ariaLabel: "trim-payment", onChangeActiveTab: onChangeActiveTab, activeTab: activeTab, paymentMethod: paymentMethod, paymentFrequency: paymentFrequency, modelYear: modelYear, payment: payment, isFetching: isFetching, error: !!error, overriddenIsSellingProvince: !!overriddenIsSellingProvince, includeFees: includeFees !== null && includeFees !== void 0 ? includeFees : false, disableMsrp: false })] }), _jsx(Column, { width: [1, 1, 1 / 2], pl: ['20px', '20px', '48px'], pr: ['20px', '20px', 'auto'], children: _jsx(TrimPaymentCheckbox, { calculatorId: INVENTORY_CALCULATOR }) })] })) : null;
};
export default InventoryTrimPayment;
